module.exports = "/images/marker.svg";